import { ObsolescencelifeCycleRisk } from "./rm-common-properties";
import { Credits } from "./credits";

export class WarehouseGroup extends Credits {
  [key: string]: any;
  _id?: string;
  _rev?: string;
  type?: string = "warehouseGroup";
  warehouseGroupId: string = "";
  warehouseGroupDescription: string = "";
  obsolescenceManagement: string = "false";
  warehouseImpact: ObsolescencelifeCycleRisk = "";
}
